
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/list-item-content",
      function () {
        return require("private-next-pages/joy-ui/api/list-item-content.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/list-item-content"])
      });
    }
  